import { isUndefined, noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { AssignmentPreviewWarningBanner } from 'domains/assignments/Components/AssignmentPreviewBanner';
import StructuredActivity from 'domains/structuredActivities/Page';
import { useNavigation } from 'utils/hooks/useNavigation';

export const PreviewStructuredActivity = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { params } = useNavigation();

  const { structuredActivityId } = params;
  if (isUndefined(structuredActivityId)) {
    throw new Error(t('notFound.pageTitle'));
  }

  return (
    <>
      <AssignmentPreviewWarningBanner />
      <div className="mb-128">
        <StructuredActivity structuredActivityId={structuredActivityId} onSubmit={noop} previewMode />
      </div>
    </>
  );
};
